import {useEffect, useState} from 'react'
import {useContentfulClient} from './use-contentful-client.hook'
import {useIntl} from 'react-intl'

export const useGetCategorieInfo = () => {
    const {locale} = useIntl()
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const contentfulClient = useContentfulClient()

    useEffect(() => {
        setIsLoading(true)
        contentfulClient
            .getEntries({
                locale,
                content_type: 'SFProductCategory',
                include: 1,
                limit: 1000
            })
            .then((response) => {
                const items = response?.items ?? []

                if (items?.length > 0) setData(items.map((item) => item.fields))
            })
            .catch((error) => console.error('>>>> error', error))
            .finally(() => setIsLoading(false))
    }, [])

    return {data, isLoading}
}
